(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProcessController', ProcessController);

    ProcessController.$inject = ['$uibModal', 'Process', 'AlertService'];

    function ProcessController($uibModal, Process, AlertService) {
        var vm = this;

        vm.processes = [];
        vm.page = 1;
        vm.openSpotColorDialog = openSpotColorDialog;

        loadAll();

        function loadAll() {
            Process.query({
                page: 0,
                size: 200,
                sort: ['id']
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.processes = data.data || [];
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function openSpotColorDialog(process) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/process/process-spot-color-dialog.html',
                controller: 'ProcessSpotColorDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: function () {
                        return process;
                    }
                }
            });

            modalInstance.result.then(function (result) {
                // 保存成功后刷新列表
                loadAll();
            });
        }
    }
})();
